var _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _path, _line1, _path2, _path3, _line10, _line11, _line12, _line13, _line14, _line15, _path4, _path5, _line16, _path6, _line17, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFloorDrain({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Floor Drain") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.16,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.32,
    y1: 5.41,
    x2: 9.45,
    y2: 0.99,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.9,
    y1: 7.06,
    x2: 10.87,
    y2: 1.44,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 0.84,
    y1: 8.57,
    x2: 12.05,
    y2: 2.1,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 1.09,
    y1: 9.87,
    x2: 13.09,
    y2: 2.97,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 1.67,
    y1: 11.36,
    x2: 13.88,
    y2: 3.93,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 2.09,
    y1: 12.03,
    x2: 14.32,
    y2: 4.64,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 2.78,
    y1: 12.89,
    x2: 14.7,
    y2: 5.48,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 3.42,
    y1: 13.49,
    x2: 14.7,
    y2: 6.42,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 4.46,
    y1: 14.22,
    x2: 15.12,
    y2: 7.25,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 5.61,
    y1: 14.74,
    x2: 15.16,
    y2: 8.68,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66,14.75c0-.09,7.89-5.09,7.89-5.09",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 8.74,
    y1: 15.12,
    x2: 14.7,
    y2: 11.08,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66.66c.06.14,8.06,8.2,8.06,8.2",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3.5c.13,0,6.52,6.56,6.52,6.56",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 5.61,
    y1: 1.25,
    x2: 14.62,
    y2: 10.74,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 4.06,
    y1: 2.02,
    x2: 13.88,
    y2: 12.28,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 3.12,
    y1: 2.76,
    x2: 13.21,
    y2: 12.89,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 12.41,
    y1: 13.63,
    x2: 2.39,
    y2: 3.55,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 1.72,
    y1: 4.55,
    x2: 11.72,
    y2: 14.12,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 10.87,
    y1: 14.57,
    x2: 1.46,
    y2: 5.09,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M.82,5.56c0,.06,8.84,9,8.84,9",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85,14.72",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 0.88,
    y1: 7.25,
    x2: 8.53,
    y2: 15.05,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.55,14.53c-.06,0-6-6.06-6-6.06",
    transform: "translate(0.34 0.34)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 4.84,
    y1: 1.57,
    x2: 14.33,
    y2: 11.33,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFloorDrain);
export default __webpack_public_path__ + "static/media/FloorDrain.7c62f90ca5c437863c30bceaa9e23039.svg";
export { ForwardRef as ReactComponent };